import set from "lodash/set";

const initStat = {};

export default function cachedDataReducer(state = initStat, action) {
  let newState = { ...state };

  switch (action.type) {
    case "CACHED_DATA_SET":
      return action.payload;

    case "CACHED_DATA_UPDATE":
      return set(newState, action.payload.key, action.payload.value);

    case "CACHED_DATA_ITEM_SET":
      if (!newState[action.payload.itemName]) {
        newState[action.payload.itemName] = {};
      }
      newState[action.payload.itemName] = action.payload.itemValue;
      return newState;
    case "CACHED_DATA_ITEM_UPDATE":
      return set(
        newState,
        newState[action.payload.itemName]?.[action.payload.itemNameKey],
        action.payload.value,
      );

    case "CACHED_DATA_ITEM_CLEAR":
      return set(newState, action.payload, null);

    case "CACHED_DATA_ARRAY_ITEM_UPDATE":
      const { arrayName, itemId, updates, replaceEntire } = action.payload;

      if (!newState[arrayName] || !Array.isArray(newState[arrayName])) {
        return newState; // Array doesn't exist, return state unchanged
      }

      // Create a new array with the updated item
      const updatedArray = newState[arrayName].map((item) => {
        if (item._id === itemId) {
          // Either replace the entire object or merge updates with existing item
          return replaceEntire ? { ...updates } : { ...item, ...updates };
        }
        return item;
      });

      // Update the state with the new array
      return { ...newState, [arrayName]: updatedArray };

    case "CACHED_DATA_CLEAR":
      return initStat;

    // Invalidate the cached full loan pipeline whenever a loan is created or a
    // loan drilldown's data changes, so the correspondents screens + loan search
    // refetch fresh data. (loanPipelineClear fires on create/update;
    // loanDrilldownSet fires whenever drilldown data is (re)set.)
    case "SET_LOAN_DRILLDOWN":
    case "CLEAR_LOAN_PIPELINE":
      if (state.loanPipeline == null) return state;
      return { ...state, loanPipeline: null };

    default:
      return state;
  }
}

export const CACHED_DATA_REDUCER_TYPES = {
  BORROWER_PORTAL_USERS: "borrowerPortalUsers",
  BORROWER_PORTAL_USERS_STAGED: "borrowerPortalUsersStaged",
  EMAIL_TEMPLATES: "emailTemplates",
  // Reference lists mirrored here on fetch (kept in sync with the dedicated
  // `users` / `fetchedSelections.correspondents` slices).
  USERS: "users",
  CORRESPONDENTS: "correspondents",
  // Full underwriting pipeline, cached for the correspondents screens + the
  // header loan search. Cleared on loan create / drilldown update (see reducer).
  LOAN_PIPELINE: "loanPipeline",
  // The LOGGED-IN user's org-group names, lowercased. Shared because two
  // surfaces gate on it at once (the header's Users menu and the Users screen's
  // tab bar) and they must agree; cleared by useGroupsHook on every membership
  // mutation so removing yourself from a group hides its surfaces immediately,
  // without a page refresh. See hooks/useIsInUserActivityGroup.js.
  USER_GROUPS: "userGroups",
};
